import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "justify-start items-center inline-flex" }
const _hoisted_2 = {
  key: 0,
  class: "self-stretch pl-4 py-1 justify-center items-center gap-2.5 flex"
}
const _hoisted_3 = { class: "flex flex-col justify-center px-[5px] py-2 h-[60px]" }
const _hoisted_4 = ["data-noImage", "data-isMega"]
const _hoisted_5 = { class: "grow shrink basis-0 flex-col justify-start items-start gap-0.5 inline-flex" }
const _hoisted_6 = {
  key: 0,
  class: "self-stretch flex-col justify-start items-end inline-flex"
}
const _hoisted_7 = {
  key: 0,
  class: "bg-icon-check icon w-3 h-2.5 bg-no-repeat bg-contain"
}

import { computed } from 'vue';
import { RichText, Image } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioCardListItem',
  props: {
    label: {},
    help: {},
    image: {},
    isSelected: { type: Boolean },
    rightLabel: {},
    rightHelp: {},
    hideCheckbox: { type: Boolean },
    isMega: { type: Boolean },
    isComparison: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const hasImage = computed(() => !!props.image?.value?.src);

const imageAlt = computed(() => {
  return props.image?.value?.alt || props.label || 'Option image';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (hasImage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Image), {
                media: _ctx.image,
                alt: imageAlt.value,
                class: "w-10"
              }, null, 8, ["media", "alt"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "grow shrink basis-0 self-stretch justify-start items-center gap-3 flex p-3 data-[noImage=true]:pl-5 data-[isMega=true]:py-4",
        "data-noImage": !hasImage.value && (_ctx.isComparison || !_ctx.isMega),
        "data-isMega": _ctx.isMega
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(RichText), {
            field: { value: _ctx.label },
            class: "text-racq-dark-grey text-base-bold text-left line-clamp-2"
          }, null, 8, ["field"]),
          _createVNode(_unref(RichText), {
            field: { value: _ctx.help },
            class: "text-racq-med-grey text-xs text-left"
          }, null, 8, ["field"])
        ]),
        (_ctx.rightLabel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(RichText), {
                field: { value: _ctx.rightLabel },
                class: "text-racq-dark-grey text-base-bold text-left"
              }, null, 8, ["field"]),
              _createVNode(_unref(RichText), {
                field: { value: _ctx.rightHelp },
                class: "text-racq-med-grey text-xs text-left"
              }, null, 8, ["field"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.hideCheckbox)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["justify-center items-center flex flex-col", _ctx.help || _ctx.isComparison ? 'self-start py-1' : 'self-stretch'])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["w-5 h-5 rounded-full self-stretch justify-center items-center inline-flex", _ctx.isSelected ? 'bg-racq-blue-active' : 'border-2 border-racq-light-blue-grey'])
              }, [
                (_ctx.isSelected)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ], 8, _hoisted_4)
    ]),
    _renderSlot(_ctx.$slots, "bottom")
  ], 64))
}
}

})